import React, { Component } from 'react';
import './index.scss';

class CustomMsgMask extends Component {
  render() {
    return (
      <div className="msg-mask">
        <div className="msg">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default CustomMsgMask;
